import * as types from '../action-types';

type openProps = {
  isOpen: boolean;
  top: number;
  left: number;
};

export const openHighlightPopover = (data: openProps) =>
  <const>{
    type: types.openHighlightPopover,
    payload: { data },
  };

export const closeHighlightPopover = () => {
  return <const>{
    type: types.closeHighlightPopover,
  };
};

export type HighlightActions = ReturnType<
  typeof openHighlightPopover | typeof closeHighlightPopover
>;
